namespace GeniuzPOS.LogManage {
    export interface LogRefundForm {
        ShopId: Serenity.StringEditor;
        PosId: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        Cashier: Serenity.StringEditor;
        RefDocNo: Serenity.StringEditor;
        CheckDoc: Serenity.IntegerEditor;
        FlagReceipt: Serenity.IntegerEditor;
        ShiftId: Serenity.IntegerEditor;
        CreateDate: Serenity.DateEditor;
    }

    export class LogRefundForm extends Serenity.PrefixedContext {
        static formKey = 'LogManage.LogRefund';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LogRefundForm.init)  {
                LogRefundForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;

                Q.initFormType(LogRefundForm, [
                    'ShopId', w0,
                    'PosId', w0,
                    'DocNo', w0,
                    'Cashier', w0,
                    'RefDocNo', w0,
                    'CheckDoc', w1,
                    'FlagReceipt', w1,
                    'ShiftId', w1,
                    'CreateDate', w2
                ]);
            }
        }
    }
}
